import React from 'react';
import Box from '@cloudscape-design/components/box';
import Checkbox from '@cloudscape-design/components/checkbox';
import SpaceBetween from '@cloudscape-design/components/space-between';

interface ActionChecklistProps {
  actions: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
}

/**
 * One checkbox per action, used in the delete dialog to choose which actions to remove.
 * Not wrapped in a FormField: that would label every checkbox "Actions to remove" for screen readers.
 */
export const ActionChecklist: React.FC<ActionChecklistProps> = ({ actions, selected, onChange, disabled }) => (
  <div role="group" aria-label="Actions to remove">
    <SpaceBetween size="xxs">
      <Box variant="awsui-key-label">Actions to remove</Box>
      {actions.map(a => (
        <Checkbox
          key={a}
          checked={selected.includes(a)}
          disabled={disabled}
          onChange={({ detail }) => onChange(detail.checked ? [...selected, a] : selected.filter(s => s !== a))}
        >
          {a}
        </Checkbox>
      ))}
    </SpaceBetween>
  </div>
);
